/* eslint-disable react/prop-types */
/* eslint-disable radix */
/* eslint-disable prefer-const */
import React from 'react';

import { TextField } from '@mui/material';
import { Container } from './styles';
import { ConfigCard } from '../../../../shared/components/ConfigCard';

export default function ReturnWindowDays({
  returnWindowDays,
  setReturnWindowDays,
}) {
  return (
    <ConfigCard title="Janela de retorno">
      <Container>
        <TextField
          type="number"
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
          value={returnWindowDays}
          onChange={(e) => {
            const { value } = e.target;
            if (value >= 7) {
              setReturnWindowDays(parseInt(value));
            } else {
              setReturnWindowDays(7);
            }
          }}
        />
      </Container>
    </ConfigCard>
  );
}
